import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useGenderPopup } from "../context/GenderPopupContext";

export default function StickyMobileCTA() {
  const { t } = useI18n();
  const { setOpen } = useGenderPopup();
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-30 sm:hidden p-3 bg-black/85 backdrop-blur-xl border-t border-white/10"
      data-testid="sticky-mobile-cta"
    >
      <button
        onClick={() => setOpen(true)}
        className="w-full flex items-center justify-center bg-[#FF6B00] text-black font-bold text-xs tracking-[0.3em] py-4 uppercase btn-glow"
      >
        {t.sticky.apply}
      </button>
    </div>
  );
}
